import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get';
import ElementInteraction from './element-interaction';

var CCElementInteraction = function CCElementInteraction(props) {
  var elementInteractionProps = _objectSpread(_objectSpread({}, props), {}, {
    eventName: 'CC_ELEMENT_INTERACTION_EVENT',
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    impressionId: props.impressionId
  });

  var ccData = {
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productId: props.productId,
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productImpressionId: props.productImpressionId
  };
  return React.createElement(ElementInteraction, _extends({
    verticalInteractionData: ccData
  }, elementInteractionProps));
};

CCElementInteraction.propTypes = {
  productId: PropTypes.number.isRequired,
  impressionId: PropTypes.string,
  productImpressionId: PropTypes.string,
  productImpressionKey: PropTypes.string
};
export default CCElementInteraction;
var CCElementInteractionConnect = connect(function (state, ownProps) {
  return {
    impressionId: get(state, "impressions[".concat(ownProps.id, "].elementImpressionHeader.impressionId")),
    productImpressionId: get(state, "impressions[".concat(ownProps.productImpressionKey, "].impressionHeader.impressionId"))
  };
})(CCElementInteraction);
export { CCElementInteractionConnect };